import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StylistLanderPage from './pages/StylistLanderPage';
import BookingLanderPage from './pages/BookingLanderPage';
import PromoLanderPage from './pages/PromoLanderPage';
import ReferralLanderPage from './pages/ReferralLanderPage';
import AffiliateRefLanderPage from './pages/AffiliateRefLanderPage';
import GatedLanderPage from './pages/GatedLanderPage';
import DeepLinkShell from './DeepLinkShell';
import SmartAppCta from './SmartAppCta';
import { WEB_APP_ORIGIN } from './storeConfig';
import './deeplink.css';

/**
 * Host-gated app for app.lookbel.com.
 * Intentionally does NOT mount www stylist-dashboard routes (/stylist/dashboard, etc.).
 */
const DeepLinkApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeLander />} />
      <Route path="/stylist/:shortCode" element={<StylistLanderPage />} />
      <Route path="/booking/:shortCode" element={<BookingLanderPage />} />
      <Route path="/service/:stylistId/:serviceId" element={<GatedLanderPage kind="service" />} />
      <Route path="/promo/:code" element={<PromoLanderPage />} />
      <Route path="/referral/:code" element={<ReferralLanderPage />} />
      <Route path="/ref/:code" element={<AffiliateRefLanderPage />} />
      <Route path="/appointment/:shortCode" element={<GatedLanderPage kind="appointment" />} />
      <Route path="/appointments/:shortCode" element={<GatedLanderPage kind="appointment" />} />
      <Route path="/chat/:conversationId" element={<GatedLanderPage kind="chat" />} />
      <Route path="/wallet" element={<GatedLanderPage kind="wallet" />} />
      <Route path="/wallet/*" element={<GatedLanderPage kind="wallet" />} />
      <Route path="/notification/:id" element={<GatedLanderPage kind="notification" />} />
      <Route path="/stripe-connect/*" element={<GatedLanderPage kind="generic" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const HomeLander: React.FC = () => (
  <DeepLinkShell>
    <div className="dl-card">
      <h1 className="dl-name">LookBel</h1>
      <p className="dl-meta">Book beauty appointments with top stylists near you.</p>
      <SmartAppCta
        title="Get the LookBel app"
        webHref={WEB_APP_ORIGIN}
        webLabel="Visit lookbel.com"
        skipCustomScheme
      />
    </div>
  </DeepLinkShell>
);

export default DeepLinkApp;
